
import { IUnidadeGestoraModel } from "src/app/models/unidade-gestora.model";
import {
	Component,
	Inject,
	OnInit,
	AfterViewInit,
	ViewChild,
} from "@angular/core";
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogConfig,
} from "@angular/material/dialog";
import { ICriterioModel } from "src/app/models/criterio.model";
import { CriteriosAvaliacaoRiscoService } from "src/app/services/criterios-avaliacao-risco.service";
import { BaseListComponent } from "src/app/shared/components/base-list/base-list.component";
import { IBaseModel } from "src/app/models/base.model";
import { ModalCancelarComponent } from "src/app/shared/components/modal-cancelar/modal-cancelar-component";
import { IMatrizRiscoControle } from "../../../model/matriz-risco-controle.model";

@Component({
	selector: "app-modal-copiar-risco",
	templateUrl: "./modal-copiar-risco.component.html",
	styleUrls: ["./modal-copiar-risco.component.scss"],
})
export class ModalCopiarRiscoComponent extends BaseListComponent implements OnInit, AfterViewInit {
		
	objPrincipal: IMatrizRiscoControle = {} as IMatrizRiscoControle;
	riscoSelecionado!: number;

	constructor(
		public matDialog: MatDialog,
		private dialogRef: MatDialogRef<ModalCopiarRiscoComponent>,
		@Inject(MAT_DIALOG_DATA) public data
	) {
		super();
		this.objPrincipal = data?.objPrincipal;
		//console.log(this.objPrincipal);
	}

	ngOnInit(): void {
		
	}

	ngAfterViewInit() {
		
	}	

	public async salvar(fechar?: boolean) {
		try {			
			if (this.riscoSelecionado == undefined || this.riscoSelecionado === 0) {
				this.exibirMensagemAlerta("Selecione um Risco Identificado para copiar as Causas e Consequências!");
				return;
			}
			this.dialogRef.close(this.riscoSelecionado);
		}
		catch (err) {
			this.exibirMensagemErro(err.mensagem.descricao);
		}
	}

	public cancelar() {
		this.dialogRef.close();
	}	
}
